import { render, staticRenderFns } from "./aFooter.vue?vue&type=template&id=d15debbc&scoped=true"
import script from "./aFooter.vue?vue&type=script&lang=js"
export * from "./aFooter.vue?vue&type=script&lang=js"
import style0 from "./aFooter.vue?vue&type=style&index=0&id=d15debbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15debbc",
  null
  
)

export default component.exports